import { Col, Form, FormInstance, Radio, Row, Select, Typography } from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import { FloatingFormItem } from '@/components/_common';
import {
  QuestSalesByCstFormValues,
  SalesByCstReportType,
} from '@/core/domain/questReport/Reports/SalesByCst/SalesByCst.types';
import { pisCofinsCstOptions } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.const';
import CfopSelectField from '@/components/_common/CfopSelectField';

interface Props {
  form: FormInstance<QuestSalesByCstFormValues>;
}

const FiscalSalesByCSTForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields form={form} />

      <Row gutter={[24, 24]}>
        <Col xs={24}>
          <Title level={5}>
            {intl.formatMessage({ id: 'report.invoice.form.reportType' })}
          </Title>

          <Form.Item
            name="reportType"
            noStyle
            initialValue={SalesByCstReportType.synthetic}
          >
            <Radio.Group buttonStyle="solid" optionType="button" size="large">
              <Radio value={SalesByCstReportType.analytical}>
                {intl.formatMessage({
                  id: 'report.invoice.form.reportType.analytical',
                })}
              </Radio>
              <Radio value={SalesByCstReportType.synthetic}>
                {intl.formatMessage({
                  id: 'report.invoice.form.reportType.synthetic',
                })}
              </Radio>
              <Radio value={SalesByCstReportType.perPart}>
                {intl.formatMessage({
                  id: 'report.invoice.form.reportType.byPieces',
                })}
              </Radio>
              <Radio value={SalesByCstReportType.perInvoice}>
                {intl.formatMessage({
                  id: 'report.invoice.form.reportType.perInvoice',
                })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col span={24} lg={14}>
          <FloatingFormItem
            name="cstPisCofins"
            label={intl.formatMessage({
              id: 'report.invoice.form.selection.cstpis/cofins',
            })}
            style={{ marginBottom: 0 }}
          >
            <Select
              mode="multiple"
              options={pisCofinsCstOptions}
              allowClear
              style={{ width: '100%' }}
              maxTagCount="responsive"
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} lg={14}>
          <FloatingFormItem name="cfopIdsToInhibit" label="Inibir CFOPs">
            <CfopSelectField
              mode="multiple"
              allowClear
              maxTagCount="responsive"
              maxTagTextLength={40}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default FiscalSalesByCSTForm;
